import { render, staticRenderFns } from "./index.vue?vue&type=template&id=95ff3174&"
import script from "./bankDetails.js?vue&type=script&lang=js&"
export * from "./bankDetails.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports